import { useContext } from 'react'
import { PricingType } from '@guestgoodie/pricing'

import * as Form from '@/features/form'
import { FormProps } from '../hooks/useSteps'
import { FormData } from '../hooks/useBillingForm'
import { BillingContext, useBillingData } from '../hooks/useBillingData'
import { InvoicePreview } from './InvoicePreview'

export function SummaryForm({ ref }: FormProps) {
  const { save, serverErrors } = useContext(BillingContext)
  const { billing } = useBillingData()

  return (
    <Form.Root<FormData>
      onSubmit={save}
      serverErrors={serverErrors}
      formRef={ref}
      values={billing as FormData}
      defaultValues={billing as FormData}
    >
      <div className="flex flex-col gap-6 p-2.5">
        {billing && (
          <InvoicePreview
            interval={billing.interval as unknown as PricingType}
            rooms={billing.rooms!}
            taxes={billing.country === 'AT' ? 0.2 : 0}
          />
        )}
        <div className="flex flex-row justify-center">
          <Form.Error name="root.serverError" />
        </div>
      </div>
    </Form.Root>
  )
}
